export default __webpack_public_path__ + "static/media/landing-background.52906bb9.svg";